// ─── Shared style constants for AccountDetail ─────────────────────────────────

export const TABLE_CONTAINER = {
  background: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 12,
  overflow: 'hidden',
  fontFamily: "'Open Sans', sans-serif",
};

export const TH_STYLE = {
  textAlign: 'left',
  padding: '10px 16px',
  fontSize: 11,
  fontWeight: 700,
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  background: '#f9fafb',
  borderBottom: '1px solid #e5e7eb',
};

export const TD_STYLE = {
  padding: '0 16px',
  fontSize: 14,
  color: '#374151',
  height: 60,
  verticalAlign: 'middle',
};

export const TAB_BAR_STYLE = {
  display: 'flex',
  borderBottom: '1px solid #e5e7eb',
  marginBottom: 28,
  gap: 0,
  fontFamily: "'Open Sans', sans-serif",
};

export function tabStyle(tab, activeTab) {
  return {
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: activeTab === tab ? 600 : 400,
    color: activeTab === tab ? '#1974f9' : '#6b7280',
    background: 'none',
    border: 'none',
    borderBottom: activeTab === tab ? '2px solid #1974f9' : '2px solid transparent',
    cursor: 'pointer',
    transition: 'color 0.15s',
    whiteSpace: 'nowrap',
  };
}

// ─── Modal chrome ─────────────────────────────────────────────────────────────
// The overlay/card/header/footer treatment shared by this view's confirmation
// modals. Extracted with the unused-license cleanup modal (CORE-3993); the
// three older modals in detail.js still inline their copies and should be
// moved onto these as they are next touched.

export const MODAL_OVERLAY = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  fontFamily: "'Open Sans', sans-serif",
};

export const MODAL_CARD = {
  background: '#fff',
  borderRadius: 12,
  padding: 28,
  width: 440,
  boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
};

export const MODAL_HEADER_ROW = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 20,
};

export const MODAL_TITLE = { fontSize: 16, fontWeight: 700, color: '#111827' };

export const MODAL_CLOSE_BTN = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: 20,
  color: '#9ca3af',
  lineHeight: 1,
  padding: 0,
};

export const MODAL_WARNING = {
  fontSize: 12,
  color: '#92400e',
  background: '#fffbeb',
  border: '1px solid #fde68a',
  borderRadius: 6,
  padding: '8px 12px',
  marginBottom: 20,
};

export const MODAL_ERROR = { fontSize: 13, color: '#dc2626', marginBottom: 12 };

export const MODAL_FOOTER_ROW = { display: 'flex', justifyContent: 'flex-end', gap: 10 };

export const BTN_SECONDARY = {
  padding: '8px 16px',
  fontSize: 13,
  borderRadius: 6,
  border: '1px solid #e5e7eb',
  background: '#fff',
  color: '#374151',
  cursor: 'pointer',
  fontFamily: "'Open Sans', sans-serif",
};

export function btnDestructive(disabled) {
  return {
    padding: '8px 16px',
    fontSize: 13,
    borderRadius: 6,
    border: 'none',
    fontWeight: 600,
    background: disabled ? '#d1d5db' : '#dc2626',
    color: '#fff',
    cursor: disabled ? 'default' : 'pointer',
    fontFamily: "'Open Sans', sans-serif",
  };
}

// The row action that opens the cleanup modal. Destructive, so it reads
// differently from this view's other (link-style) table actions.
export function btnRowDestructive(enabled) {
  return {
    padding: '6px 12px',
    fontSize: 12,
    borderRadius: 6,
    fontFamily: "'Open Sans', sans-serif",
    border: `1px solid ${enabled ? '#fecaca' : '#e5e7eb'}`,
    background: '#fff',
    color: enabled ? '#dc2626' : '#d1d5db',
    cursor: enabled ? 'pointer' : 'default',
  };
}
